/**
 * NavbarHeightCalculator Component
 * Dynamically calculates navbar height and applies it as a CSS variable
 * This ensures proper spacing regardless of navbar content changes
 */
import { useEffect } from 'react';

const NavbarHeightCalculator = () => {
  useEffect(() => {
    const updateNavHeight = () => {
      const nav = document.querySelector('.navbar-wrapper');
      if (nav) {
        const height = nav.offsetHeight;
        document.documentElement.style.setProperty('--nav-height', `${height}px`);
      }
    };

    // Run on mount
    updateNavHeight();

    // Update on window resize
    window.addEventListener('resize', updateNavHeight);

    // Update when DOM changes (for dynamic content)
    const observer = new MutationObserver(updateNavHeight);
    const nav = document.querySelector('.navbar-wrapper');
    if (nav) {
      observer.observe(nav, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
    }

    // Cleanup
    return () => {
      window.removeEventListener('resize', updateNavHeight);
      observer.disconnect();
    };
  }, []);

  // This component doesn't render anything
  return null;
};

export default NavbarHeightCalculator;

